import getObjectPropertyValue from './getObjectPropertyValue.js';
export default getObjectPropertyValue;
export { getObjectPropertyValue };
//# sourceMappingURL=index.js.map